const colors = {
  theme: {
    primary: '#243F81',
    secondary: '#5073B9'
  },
  dashboardSidebar: {
    background: '#5073B9'
  },
  white: '#fff',
  black: '#000'
};

export default colors;
